import { Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import styles from '../../../resources/theme/global'
import { fetchBank } from '../BankActions'
import { getBankListData } from '../BankReducer'

import Edit from './Edit'
// import Filter from './Filter'
import List from './List'
import New from './New'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'
import Filter from './Filter'
import BankTransfer from './BankTransfer'

class ServiceCategory extends Component {
  componentDidMount() {
    const { fetchBank } = this.props
    fetchBank()
  }

  render() {
    const { classes, permissionUser, filters } = this.props

    return (
      <>
        <BaseCreatePage
          page="Financeiro"
          path="Bancos"
          pageLink="/bank"
          hiddenReturn
        >
          <Grid container spacing="3" style={{ marginTop: '1em' }}>
            <Grid item xs={12}>
              <Filter />
            </Grid>
            {permissionUser?.some(p => p.name === 'read-bancos') && (
              <Grid item xs={12}>
                <List {...this.props} />
              </Grid>
            )}
          </Grid>
        </BaseCreatePage>

        {permissionUser?.some(p => p.name === 'create-bancos') && (
          <Route path="/bank/new" component={New} />
        )}
        {permissionUser?.some(p => p.name === 'create-bancos') && (
          <Route path="/bank/transfer" component={BankTransfer} />
        )}
        {permissionUser?.some(p => p.name === 'update-bancos') && (
          <Route path="/bank/:id/edit" component={Edit} />
        )}
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...getBankListData(state),
  filters: state.bank.filters,
  permissionUser: state.auth.permissionUser,
  permissions: state.auth.permissions || [],
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchBank,
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ServiceCategory))
